module.exports = __webpack_public_path__ + "img/21_Pylorus.4bd73746.png";